import { render, staticRenderFns } from "./PaymentBtn.vue?vue&type=template&id=44c25abf&scoped=true"
import script from "./PaymentBtn.vue?vue&type=script&lang=js"
export * from "./PaymentBtn.vue?vue&type=script&lang=js"
import style0 from "./PaymentBtn.vue?vue&type=style&index=0&id=44c25abf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c25abf",
  null
  
)

export default component.exports